import request from '@/utils/workFlowRequest'
import constants from '@/utils/constants'
import Vue from 'vue'
const ProcessInstanceService = {
  state: {},

  mutations: {},

  actions: {
    /**
     * 通过流程实例id查询流程审批记录
     */
    getProcessHistoryInfoList({ commit }, processId) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflow/processInstance/getHistoryInfoByProcessId/' + processId).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 通过流程实例id获取历史流程图
    getHistoryProcessImageByProcessId({ commit }, processId) {
      console.log(Vue.prototype)
      return new Promise((resolve, reject) => {
        resolve(Vue.prototype.$FILE_SERVER + 'workflow/processInstance/getHistoryProcessImage/' + processId)
      })
    },
    /**
     * 查询当前用户进行中的流程
     */
    getCurrentUserProcessInstRunningByPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflow/processInstance/getCurrentUserProcessInstRunningByPage', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 查询当前用户已完成的流程
     */
    getCurrentUserProcessInstFinishByPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflow/processInstance/getCurrentUserProcessInstFinishByPage', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 运行中的实例
     */
    getProcessInstRunningByPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflow/processInstance/getProcessInstRunningByPage', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 完成的实例
     */
    getProcessInstFinishByPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflow/processInstance/getProcessInstFinishByPage', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 提交申请，启动流程实例
     */
    workflowStartProcess({ commit }, formValueId) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + `workflow/processInstance/startProcess`, formValueId).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除运行中的实例，删除历史记录,删除业务与流程关联信息
    deleteRuntimeProcessAndHisInst({ commit }, processInstId) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + `workflow/processInstance/deleteRuntimeProcessAndHisInst/${processInstId}`, {}).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除已完成的实例，删除历史记录,删除业务与流程关联信息
    deleteFinishProcessAndHisInst({ commit }, processInstId) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + `workflow/processInstance/deleteFinishProcessAndHisInst/${processInstId}`, {}).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 撤销申请
    cancelProcessApply({ commit }, processInstId) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + `workflow/processInstance/cancelProcessApply/${processInstId}`, {}).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default ProcessInstanceService
